// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__T1qtG","errors":"Errors_errors__yqGVD"};